function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudio = function SvgAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 3C11.2044 3 10.4413 3.27092 9.87868 3.75315C9.31607 4.23539 9 4.88944 9 5.57143V12.4286C9 13.1106 9.31607 13.7646 9.87868 14.2468C10.4413 14.7291 11.2044 15 12 15C12.7956 15 13.5587 14.7291 14.1213 14.2468C14.6839 13.7646 15 13.1106 15 12.4286V5.57143C15 4.88944 14.6839 4.23539 14.1213 3.75315C13.5587 3.27092 12.7956 3 12 3Z",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10V11.7778C18 13.428 17.3679 15.0107 16.2426 16.1776C15.1174 17.3444 13.5913 18 12 18C10.4087 18 8.88258 17.3444 7.75736 16.1776C6.63214 15.0107 6 13.428 6 11.7778V10",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18V21",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21H15",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgAudio;